"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _css = require("../css.js");

var _Polygon = require("../geom/Polygon.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/ZoomToExtent
 */


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-zoom-extent'] Class name.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {string|HTMLElement} [label='E'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Fit to extent'] Text label to use for the button tip.
 * @property {import("../extent.js").Extent} [extent] The extent to zoom to. If undefined the validity
 * extent of the view projection is used.
 */

/**
 * @classdesc
 * A button control which, when pressed, changes the map view to a specific
 * extent. To style this control use the css selector `.ol-zoom-extent`.
 *
 * @api
 */
var ZoomToExtent =
/** @class */
function (_super) {
  __extends(ZoomToExtent, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function ZoomToExtent(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      target: options.target
    }) || this;
    /**
     * @type {?import("../extent.js").Extent|null}
     * @protected
     */

    _this.extent = options.extent ? options.extent : null;
    var className = options.className !== undefined ? options.className : 'ol-zoom-extent';
    var label = options.label !== undefined ? options.label : 'E';
    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Fit to extent';
    var button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.title = tipLabel;
    button.appendChild(typeof label === 'string' ? document.createTextNode(label) : label);
    button.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this), false);
    var cssClasses = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL;
    var element = _this.element;
    element.className = cssClasses;
    element.appendChild(button);
    return _this;
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */


  ZoomToExtent.prototype.handleClick_ = function (event) {
    event.preventDefault();
    this.handleZoomToExtent();
  };
  /**
   * @protected
   */


  ZoomToExtent.prototype.handleZoomToExtent = function () {
    var map = this.getMap();
    var view = map.getView();
    var extent = !this.extent ? view.getProjection().getExtent() : this.extent;
    view.fitInternal((0, _Polygon.fromExtent)(extent));
  };

  return ZoomToExtent;
}(_Control["default"]);

var _default = ZoomToExtent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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